import { create } from 'zustand';

export interface TableSettings {
  menteeFields: [];
  mentorFields: [];
  adminFields: [];
}

interface TableSettingsState {
  tableSettings: TableSettings;
  setTableSettings: (settings: TableSettings) => void;
}

const useTableSettingsStore = create<TableSettingsState>(set => ({
  tableSettings: {
    menteeFields: [],
    mentorFields: [],
    adminFields: [],
  },
  setTableSettings: (tableSettings: TableSettings) => set({ tableSettings: tableSettings }),
}));

export const useTableSettings = () => useTableSettingsStore(state => state.tableSettings);
export const useSetTableSettings = () => useTableSettingsStore(state => state.setTableSettings);
